<script setup>
import { ref, watch} from 'vue'

const props = defineProps({
	show: {
		type: Boolean,
		default: false,
	},
	type: {
		type: String,
		required: true,
	},
	msgContent: {
		type: String,
		required: true
	}	
})		


const showToast = ref(props.show)
const typeClass = ref(props.type)
function hideToast() {
	showToast.value = false
} 

watch(
	() => props.show,
		(val) => {
		showToast.value = val;
	}
);

 watch(
	() => props.type,
		(val) => {
		typeClass.value = val;
	}
);
</script>

<template>
	<div v-if="showToast" class="toast-container"  :class="typeClass">
		<div class="toast-content" :class="typeClass">
			<span v-if="props.type == 'success'" :class="typeClass">
				<i class="fa-solid fa-circle-check"></i>
			</span>
			<span v-else-if="props.type == 'warning'" :class="typeClass">
				<i class="fa-solid fa-triangle-exclamation"></i>
			</span>
			<span v-else-if="props.type == 'error'" :class="typeClass">
				<i class="fa-solid fa-circle-exclamation"></i>
			</span>
			<!-- else info message -->
			<span v-else :class="typeClass">
				<i class="fa-solid fa-circle-exclamation"></i>
			</span>												
			<span v-html="props.msgContent"></span>
		</div>
		<div class="toast-controls">
			<div class="toast-action">
			</div>
			<div class="toast-hide">
				<button class="btn-tertiary" :class="typeClass" @click="hideToast">Dismiss</button>
			</div>	
		</div>
	</div>
</template>
   
<style scoped>
	.toast-container {
		min-width: 22.75rem;
		line-height: var(--font-line-height-Base, 24px); /* 150% */
		display: flex;
		justify-content: space-between;
		align-items:center;
		padding: var(--spacing-md, 8px) var(--spacing-lg, 16px);
		border-radius: var(--radius-lg, 8px);
		border: 1px solid var(--border-color-input-Border, #A9B7C7);
		background: var(--surfaces-surface-tertiary, #FAFAFA);
		box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.15);		
	}

	.toast-content {
		font-size: var(--font-size-Base);
		font-family: var(--font-family-Title);
		color: var(--brand-color-MedGrey);
	}

	.btn-tertiary {
		min-height: unset;
		height: unset;
		padding: 0 0 0 2rem;
	}

	/* info */
	.toast-container.info {
		border: 1.5px solid var(--brand-color-IndicatorsBlue);
		color: var(--brand-color-IndicatorsBlue); 
	}

	.toast-content.info, .toast-content .info {
		color: var(--brand-color-IndicatorsBlue); 
		padding-right: .75rem;
	}

	.btn-tertiary.info {
		color: var(--brand-color-IndicatorsBlue); 
	}

	/* success */
	.toast-container.success {
		border: 1.5px solid var(--brand-color-Green);
		color: var(--brand-color-Green);
	}

	.toast-content.success, .toast-content .success {
		color: var(--brand-color-Green);
		padding-right: .75rem;
	}

	.btn-tertiary.success {
		color: var(--brand-color-Green); 
	}

	/* warning */
	.toast-container.warning {
		border: 1.5px solid var(--brand-color-BurntYellow);
		color: var(--brand-color-BurntYellow);
	}

	.toast-content.warning, .toast-content .warning {
		color: var(--brand-color-BurntYellow);
		padding-right: .75rem;
	}

	.btn-tertiary.warning {
		color: var(--brand-color-BurntYellow); 
	}	

	/* error */
	.toast-container.error {
		border: 1.5px solid var(--brand-color-Red);
		color: var(--brand-color-Red); 
	}

	.toast-content.error, .toast-content .error {
		color: var(--brand-color-Red); 
		padding-right: .75rem;
	}

	.btn-tertiary.error {
		color: var(--brand-color-Red); 
	}

</style>